import type { PropsWithChildren } from "react";
import { placeNumberOffsetPx } from "src/components/TripPlanner/Headings/PlaceTitle";
import { color, spacing } from "src/theme";
import { A11yOutline } from "src/utils/accessibility";
import { desktopLayout, mobileLayout } from "src/utils/hooks/useLayout";
import styled, { css } from "styled-components";
import { useTripPlannerContext } from "../hooks/useTripPlannerContext";

type TripPlannerPlaceProps = PropsWithChildren<{
  index: number;
  isLast?: boolean;
  isDragging?: boolean;
  isBeingDragged?: boolean;
}>;

export function TripPlannerPlace({
  index,
  children,
  isDragging,
  isBeingDragged,
  isLast,
}: TripPlannerPlaceProps) {
  const { loadingIndex } = useTripPlannerContext();

  return (
    <TripPlanEntryWrapper
      $isDragging={isDragging}
      $isBeingDragged={isBeingDragged}
      $hideTimeline={isLast}
      $loading={loadingIndex?.includes(index)}
      $isFirst={index === 0}
    >
      {children}
    </TripPlanEntryWrapper>
  );
}

const tripPlanTimeline = css`
  position: relative;

  > * {
    position: relative;
  }

  &::before {
    content: "";
    width: 2px;
    height: 100%;
    display: block;
    background-color: ${color.n40};
    position: absolute;

    left: calc(${placeNumberOffsetPx}px + ${spacing.md} - 1px);
    top: ${spacing.xl};
  }
`;

const newUitripPlanTimeline = css`
  position: relative;

  > * {
    position: relative;
  }

  &::before {
    content: "";
    width: 2px;
    height: 100%;
    display: block;
    background-color: ${color.n30};
    position: absolute;

    top: ${spacing.xxxl};
    left: -45px;
  }
`;

export const TripPlanEntryWrapper = styled.li<{
  $hideTimeline?: boolean;
  $loading?: boolean;
  $isDragging?: boolean;
  $isBeingDragged?: boolean;
  $isFirst?: boolean;
}>`
  position: relative;
  display: ${({ $loading }) => ($loading ? "none" : "block")};
  width: 100%;
  list-style-type: none;
  ${A11yOutline};

  ${({ $isFirst }) =>
    $isFirst &&
    css`
      ${mobileLayout} {
        margin-top: ${spacing.lg};
      }
    `}

  ${mobileLayout} {
    ${({ $hideTimeline }) => !$hideTimeline && tripPlanTimeline};
  }

  ${desktopLayout} {
    ${({ $hideTimeline }) => !$hideTimeline && newUitripPlanTimeline}
  }
`;
